import React, { useState, useEffect, InputHTMLAttributes } from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import InputUnstyled from '@mui/base/InputUnstyled';
import { ValidationError } from '@thrivetribe/mvf.ui.atoms.validation-error';
import './formik-text-input.scss';

export interface FormikSearchInputProps<T> extends InputHTMLAttributes<T> {
  name: string;
  label?: string;
  errorMessage?: string;
  [key: string]: any;
}

export const FormikSearchInput = (
  props: FormikSearchInputProps<HTMLInputElement>
) => {
  const { className, label, name, errorMessage, disabled, ...rest } = props;
  const [field, meta] = useField(name);
  const [fieldDisabled, setFieldDisabled] = useState(false);

  useEffect(() => {
    if (disabled) {
      setFieldDisabled(true);
    } else {
      setFieldDisabled(false);
    }
  }, [disabled]);

  return (
    <>
      <label className="text-input__label">
        {label}
        <div>
          <InputUnstyled
            {...field}
            autoComplete="none"
            className={classNames('text-input', className)}
            disabled={fieldDisabled}
            error={
              (!!meta.error && meta.touched) || (errorMessage ? true : false)
            }
            {...rest}
          />
        </div>
        {meta.error !== undefined && meta.touched && (
          <ValidationError errorMessage={meta.error} />
        )}

        {!meta.error && meta.touched && errorMessage && (
          <ValidationError errorMessage={errorMessage} />
        )}
      </label>
    </>
  );
};
